import React, { useState } from 'react';
import Zoom from 'react-reveal/Zoom';
import './hero.css'

import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Image from '../elements/Image';
import Whats from '../elements/Whats';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section id="sobre"
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <div className='wpp'>
              <Whats/>
            </div>
            
            <Zoom left>
              <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
                <br />
                <br />
                João Guilherme Piá de Andrade <br/> <span className="text-color-primary" id='CD'>Cirurgião Dentista</span>
              </h1>
            </Zoom>
            <Zoom right>
              <div className="container-xs">
                <p className="m-0 mb-32 reveal-from-bottom text-color-textos" data-reveal-delay="400" >
                Com mais de 30 anos de experiência como cirurgião dentista, meu compromisso vai além da funcionalidade bucal. Tenho o privilégio de promover autoestima e saúde por meio de procedimentos de harmonização orofacial e aplicação de lentes de contato dental. Essas técnicas não só aprimoram a estética facial, mas também proporcionam bem-estar emocional aos pacientes. Estou dedicado a essas áreas da odontologia com o objetivo de transformar sorrisos e vidas.
                </p>
              </div>
            </Zoom>
          </div>
          <Zoom left>
            <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="1000">
              <Image
                className="has-shadow-fotoprincip"
                src={require('./../../assets/images/foto-dentistaaa.jpg')}
                alt="Hero"
                width={896}
                height={404} />
            </div>
          </Zoom>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
